import React, { Fragment } from 'react';
import { Suspense, useEffect, useState, useContext } from 'react';
import { BrowserRouter, Route, Routes, Navigate, useParams } from 'react-router-dom';
import Loader from '../Layout/Loader';
import LayoutRoutes from '../Route/LayoutRoutes';
import LoginForm, { SignUpForm, ForgotPasswordForm } from '../GlobalComponents/Authentication/';
import { AccountContext } from '../GlobalComponents/Authentication/Accounts';
import Survey from '../Components/Surveys';

const Routers = () => {

        const [authenticated, setAuthenticated] = useState(false);
        const [authenticating, setAuthenticating] = useState(true);

        /**
         * Destination to return to after login. Captures the full requested URL
         * (path + query + hash) so deep links keep their params through auth.
         * Auth pages (login/signup/forgot/logout) fall back to /dashboard to avoid
         * redirect loops.
         */
        const [currentUrl, setCurrentUrl] = useState(['/signup', '/login', '/forgotPassword'].includes(window.location.pathname) ? '/dashboard' : window.location.pathname === '/logout' ? '/dashboard' : window.location.pathname + window.location.search + window.location.hash);

        const { getSession, logout } = useContext(AccountContext);

        useEffect(() => {
                /**
                 * If the user is not authenticated, we will check their
                 * cognito session.
                 */
                if (!authenticated)
                {
                        getSession()
                                .then(session => { 
                                        setAuthenticated(true)
                                })
                                .catch(error => {
                                        setAuthenticating(false)
                                        logout()
                                })
                } else setAuthenticating(false)

        }, [authenticated, authenticating]);

        return (
            <BrowserRouter >
                <>
                    <Suspense fallback={<Loader />}>
                        <Routes>
                                {authenticated ?
                                        <Fragment>
                                                <Route path={`/`} element={<Navigate to={`${process.env.PUBLIC_URL}/dashboard`} />} /> 
                                                <Route path={`/login`} element={<Navigate to={`${process.env.PUBLIC_URL + currentUrl}`} />} /> 
                                                <Route path={`/*`} element={<LayoutRoutes />} /> 
                                        </Fragment>
                                                : <Route path={`/`} element={<Navigate to={`${process.env.PUBLIC_URL}/login`} />} />}
                                <Route exact path={`${process.env.PUBLIC_URL}/login`} element={authenticating ? <Loader /> : <LoginForm redirect_to={currentUrl} authenticating={false}/>} />
                                <Route exact path={`${process.env.PUBLIC_URL}/signup`} element={<SignUpForm />} />
                                <Route exact path={`${process.env.PUBLIC_URL}/forgotPassword`} element={<ForgotPasswordForm />} />
                                <Route path={`${process.env.PUBLIC_URL}/surveys`} element={<Survey />} />
                                <Route path={`/*`} element={<Navigate to={`${process.env.PUBLIC_URL}/login`} />} />
                        </Routes>
                    </Suspense>
                </>
            </BrowserRouter>
        );
};

export default Routers;